import { ReactElement } from 'react'
import { t } from '@lingui/macro'

import { Placeholder } from './placeholder';
import { PlaceholderProps } from './placeholder.types';


/** EMPTY STATE */
export const EmptyState = ({
  title,
  illustration,
  description,
  children,
  visible,
  firstButton,
}: PlaceholderProps): ReactElement | null => {
  return (
    <Placeholder
      title={title}
      illustration={illustration}
      description={description || t`There is no data yet`}
      children={children}
      visible={visible}
      firstButton={firstButton}
    />
  )
}